import tsRest from 'ts-rest-client';
import { SiteInfoModel } from './models/site-info-model';

/**
 * Retrieve some info about the site
 */
export async function getSiteInfo(integName: string): Promise<SiteInfoModel> {
    // Load the urls for this integration
    return tsRest.get("/integration/" + integName + "/siteinfo")
}


/**
 * Get the site settings that tells us that we should hide event detail links on the items
 * of a package because they are meaningless.
 */
export async function getHidePackageEventDetailLinksSetting(integName: string): Promise<boolean> {
    const hideLink = await tsRest.get("/integration/" + integName + "/hidepackageeventdetaillink");
    return hideLink;
}